body > announcement-bar {
  display: block;
  background: var(--color-dark-gray);
  padding-block: .75rem;
  padding-inline: 1rem 5rem;
  font-weight: bold;
  text-align: center;
  color: var(--color-light-orange);

  p {
    margin-block-end: 0.75rem;
    line-height: 1.2;
  }

    p:last-of-type {
      margin-block-end: 0rem;
    }

  p > a {
    color: var(--color-lightest-orange);
    text-decoration: none;

    > sl-icon {
      vertical-align: -0.15em;
    }
  }
}

body > nav {
  view-transition-name: navbar;
  z-index: 1;
  position: relative;
  margin: var(--sl-spacing-x-large) 0 var(--sl-spacing-large);
  font-weight: 520;
}

@media (max-width: 1023px) {

body > nav {
    margin: var(--sl-spacing-medium) 0;
}
  }

body > nav.edge {
    background: linear-gradient(
      to bottom,
      white 0%,
      rgb(255, 251, 235) 90%,
      white 100%
    );
  }

body > nav a[aria-current] {
    text-decoration-thickness: 5px;
    text-decoration-skip: none;
    text-underline-offset: 0.3em;
  }

body > nav .logo {
    width: 320px;
    margin-top: -45px;
  }

@media (max-width: 1023px) {

body > nav .logo {
      margin-top: -20px;
  }
    }

body > nav sl-button[menutoggle] {
    margin-top: -45px;
  }

body > nav kbd {
    position: absolute;
    margin-left: 0.7rem;
    font-size: 70%;
    font-weight: var(--body-font-weight);
    opacity: 0.5;
  }

navbar-inner,
footer-inner {
  display: block;
  max-width: var(--max-content-width);
  margin: 0 auto;
}

bridgetown-search-form input {
  display: block;
  appearance: none;
  font-family: inherit;
  font-size: 1em;
  font-weight: 520;
  margin-bottom: 0.3em;
  padding: 0.2em 0.6em;
  width: calc(100% - 1.3em);
  background: #fff;
  opacity: 0.5;
  border: 1px solid var(--color-light-gray);
  border-radius: 1em;
  box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
  color: inherit;
}

bridgetown-search-form input:focus,
  bridgetown-search-form input:hover {
    opacity: 1;
  }

@keyframes swingBackAndForth {
  0% {
    transform: rotate(-7deg);
  }
  4.5% {
    transform: rotate(-16deg);
  }
  11.5% {
    transform: rotate(-7deg);
  }
  18% {
    transform: rotate(-10deg);
  }
  25% {
    transform: rotate(-7deg);
  }
  30% {
    transform: rotate(-8deg);
  }
  37% {
    transform: rotate(-7deg);
  }
}

edge-label {
  position: absolute;
  left: 7.3rem;
  top: 4.5rem;
  margin: 0;
  font-size: 0.9rem;
  font-weight: bold;
  transform: rotate(-7deg);
  transform-origin: 99% 2%;
  background: var(--color-orange);
  color: white;
  padding: 0.25em 0.7em;
  border-radius: 4px 2px 4px 4px;
  box-shadow: 0px 11px 6px -7px rgba(0, 0, 0, 0.15);
  text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

  animation: swingBackAndForth 8s;
  animation-delay: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
}

@media (max-width: 1023px) {

edge-label {
    font-size: 0.75rem;
    top: 5.15rem;
    left: 7.75rem;
}
  }

/*# sourceMappingURL=data:application/json;base64,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 */